import { createFileRoute } from "@tanstack/react-router";

import { EntryPage } from "../../../features/auth/EntryPage";
import { signInSearchOf } from "../../../features/auth/signInSearch";

export const Route = createFileRoute("/_public/sign-in/")({
  validateSearch: signInSearchOf,
  component: function SignIn() {
    return <EntryPage intent="sign-in" />;
  },
});
